<template>
  <div class="block-featured-videos container">
    <client-only>
      <ais-instant-search
        :index-name="videosIndex"
        :routing="undefined"
        :search-client="searchClient"
        :insights="true"
        :future="{
          preserveSharedStateOnUnmount: true,
        }"
      >
        <ais-configure :analytics="true" :hits-per-page.camel="8" :filters="predefinedFilters" :distinct="true" />

        <featured-block-header :title="section.title" :intro="section.intro" />

        <div
          class="block-featured__inner"
          :class="{
            'has-menu': hasMenu,
          }"
        >
          <categories-menu v-show="hasMenu">
            <ais-hierarchical-menu :attributes="['categories.lvl0', 'categories.lvl1']" :transform-items="transformItems" />
          </categories-menu>

          <div>
            <ais-state-results>
              <ais-hits>
                <template #default="{ items }">
                  <featured-videos-list :items="items" :has-menu="hasMenu" />
                </template>
              </ais-hits>
            </ais-state-results>
          </div>
        </div>
      </ais-instant-search>
    </client-only>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useNuxtApp, useRuntimeConfig } from '#app';
import { useGlobalsStore } from '@/stores/globals';
import type { SearchConfig } from '~/plugins/search';
import type { SectionProps } from '~/types/components';
import { useSectionProps } from '~/composables/blocks';
import { useAlgoliaFilters } from '~/composables/algolia-filters';
import CategoriesMenu from '~/components/global/components/categories-menu/CategoriesMenu.vue';
import FeaturedVideosList from '~/components/global/components/featured/FeaturedVideosList.vue';
import FeaturedBlockHeader from '~/components/global/components/featured/FeaturedBlockHeader.vue';

const hasMenu = ref(false);
const props: SectionProps = defineProps(useSectionProps());
const globals = useGlobalsStore();
const config = useRuntimeConfig();
const { menuFilters } = useAlgoliaFilters();
const { client: searchClient } = useNuxtApp().$search as SearchConfig;
const predefinedFilters = computed(() => props.section.filters);
const videosIndex = computed(() => config.public.algoliaVideosIndex);
const searchCategoriesTree = computed(() => globals.searchSettings?.categories_tree);

function transformItems(items) {
  items = menuFilters(props.section.display_type?.value, items, props.section.filters, searchCategoriesTree.value);
  hasMenu.value = !props.section.hide_categories_filter && items?.length > 0;
  return items;
}
</script>
